import React from 'react';

import { CommaSeparator } from '../../../AppUtil/AppUtil';
import { hot } from 'react-hot-loader';

export default hot(module)(function Base(props) {
	const headingClass = props.customHeadingClass || 'light-gray';
	const valueClass = props.customValueClass || 'loan_id';
	const containerClass = props.customContainerClass || 'loan_id_container';

	return (
		<div className={`base-container ${containerClass}`}>
			<p className={headingClass}>{props.heading}</p>
			<p className={valueClass}>
				{props.heading === 'Loan ID'
					? `LA${String(props.value).padStart(5, '0')}`
					: props.heading === 'Loan Amount'
					? CommaSeparator(props.value)
					: props.value}
			</p>
		</div>
	);
});
